
export default {
  name: 'IconClose-24x24',
  data() {
    return {
      boutiqueColor: this.$cp.black,
      defaultColor: this.$cp.primary_main,
    };
  },
  computed: {
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    fillColor() {
      return this.isBoutiquePage ? this.boutiqueColor : this.defaultColor;
    },
  },
};
